// extracted by mini-css-extract-plugin
module.exports = {"hoverStyle":"style_hoverStyle__n8luE","overlayLink":"style_overlayLink__tyzlE","readMoreLink":"style_readMoreLink__WJwW4"};